import { PartialTranslation } from '../translations';

export const zh_HK: PartialTranslation = {
  newChat: '新建對話',
  search: '搜尋',
  user: '用戶',
  settings: '設定',
  language: '語言',
  getHelp: '獲取幫助',
  viewAllPlans: '查看所有計劃',
  learnMore: '了解更多',
  logOut: '登出',
  chooseLanguage: '選擇語言',
  chooseYourPreferredLanguage: '選擇您的首選語言',
  searchLanguages: '搜尋語言...',
  autoDetect: '自動檢測',
  noLanguagesFound: '未找到匹配的語言',
  askAnything: '詢問任何問題',
  lawhelperAi: 'Lawhelper.ai',
  personal: '個人',
  freePlan: '免費計劃',
  current: '當前',
  close: '關閉',
  archive: '歸檔',
  delete: '刪除',
  confirmDelete: '確定要刪除這個對話嗎？',
  confirmArchive: '確定要歸檔這個對話嗎？',
  deleteCannotUndo: '此操作無法撤銷。',
  archiveCanFind: '歸檔後您可以在歸檔列表中找到它。',
  
  // 資源面板
  resources: '資源',
  addResource: '新增資源',
  deleteResource: '刪除資源',
  noMatchingResourcesFound: '未找到匹配的資源',
  noResourcesAvailable: '暫無可用資源',
  hideResources: '隱藏資源',
  showResources: '顯示資源',
  
  // 聊天輸入框
  typeMessage: '輸入訊息...',
  thinkingOptions: '思維選項',
  deleteFile: '刪除檔案',
  clearSelection: '清除選擇',
  addAttachment: '新增附件',
  sendMessage: '傳送訊息',
  
  // 思考模式選項
  deepInsight: '深度洞察 · 表面分析',
  deepInsightDesc: '快速理解關鍵要點',
  deepExploration: '深度探索 · 全面分析',
  deepExplorationDesc: '多維度深入研究',
  deepDeconstruction: '深度解構 · 系統論證',
  deepDeconstructionDesc: '逐層遞進分析',
  
  // 寫作模式選項
  contractReview: '合約審查 · 風險識別',
  contractReviewDesc: '條款分析和合規檢查',
  textPolish: '文本潤色 · 專業表達',
  textPolishDesc: '語言優化和結構調整',
  legalDocuments: '法律文書 · 標準起草',
  legalDocumentsDesc: '專業法律文檔寫作',

  // 认证和隐私翻译
  login: '登入',
  register: '註冊',
  welcomeBack: '歡迎使用 LawHelper',
  loginSubtitle: '您的AI法律研究助手',
  continueWithGoogle: '使用 Google 登入',
  continueWithMicrosoft: '使用 Microsoft 登入',
  continueWithWeChat: '微信登入',
  orContinueWith: '或使用',
  emailTab: '電郵',
  phoneTab: '電話',
  emailPlaceholder: '請輸入電郵',
  phonePlaceholder: '請輸入電話號碼',
  codePlaceholder: '請輸入6位驗證碼',
  sending: '發送中...',
  verifying: '驗證中...',
  verify: '驗證',
  sendMagicLink: '發送登入連結',
  getVerificationCode: '獲取驗證碼',
  resendCode: '重新發送',
  resendIn: '重新發送',
  magicLinkSent: '登入連結已發送到您的郵箱',
  magicLinkHint: '我們將向您的郵箱發送一個安全連結',
  otpSent: '驗證碼已發送',
  agreeToTerms: '繼續即表示您同意',
  privacyPolicy: '私隱政策',
  termsOfService: '服務條款',
  and: '和',
  privacyTitle: '您的私隱很重要',
  privacyIntro: '我們使用Cookie和類似技術為您提供最佳體驗。',
  essentialCookies: '必要Cookie',
  essentialDesc: '網站運作所必需',
  analyticsCookies: '分析Cookie',
  analyticsDesc: '幫助我們改進服務',
  marketingCookies: '市場推廣Cookie',
  marketingDesc: '用於個人化內容',
  acceptAll: '全部接受',
  essentialOnly: '僅必要',
  customize: '自訂',
  savePreferences: '儲存設定',
  back: '返回',
  readPrivacyPolicy: '閱讀私隱政策',
  cookiePolicy: 'Cookie政策',
  gdprCompliance: 'GDPR',
  piplCompliance: '個人資料保護法',

  // AI工具面板
  aiReview: 'AI審查',
  aiDraft: 'AI起草',
  smartAssistant: '模板填寫',

  // 知识库搜索
  enableKnowledgeSearch: '啟用知識庫搜索',
  knowledgeSearchDesc: 'AI 回答時優先從您的文檔中搜索',
  clickToDisable: '點擊關閉',
  clickToEnable: '點擊開啟',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: '關閉資源面板',
  uploading: '正在上載 %{fileName}...',
  processing: '正在處理 %{fileName}...',
  uploadSuccess: '✓ %{fileName} 上載成功',
  uploadError: '✗ 上載失敗: %{error}',
  quickAnswer: '快速回答',
  quickAnswerDesc: '簡單問題快速回應',
  cancelRequest: '取消',
  library: '資料庫',
  filterAll: '全部',
  filterChat: '對話',
  filterReview: '審查',
  filterDraft: '起草',
  filterTemplate: '範本',
  filterForm: '表格',
  thinking: '思考中...',
  thinkingProcess: '思維過程',
  analyzingLegalLogic: '正在分析法律邏輯...',
  lawhelperThinking: 'Lawhelper 正在思考...',
  serviceError: '服務異常',
  uploaded: '已上載',
  settingsGeneral: '一般',
  settingsNotifications: '通知',
  settingsAppearance: '外觀',
  settingsProfile: '個人檔案',
  settingsResponseNotifications: '回覆通知',
  settingsResponseNotificationsDesc: 'AI 回覆完成時通知',
  settingsColorMode: '色彩模式',
  settingsLight: '淺色',
  settingsDark: '深色',
  settingsSystem: '系統',
  about: '關於',
  reviewTitle: '文件審查',
  exitReview: '退出審查',
  uploadPrompt: '上載 PDF 開始審查',
  uploadButton: '選擇檔案',
  startChatConfig: '輸入「審查此文件」開始',
  reviewPlaceholder: '輸入訊息或「審查此文件」...',
  analyzing: '審查中...',
  reviewComplete: '審查完成',
  issuesFound: '發現 %{count} 個問題',
  draftTitle: '法律文書起草',
  draftPlaceholder: '在此編輯或讓 AI 生成...',
  analyzingTemplate: '正在分析範本 %{name}...',
  templateAnalyzed: '✅ 範本 %{name} 分析完成！',
  templateAnalysisPrompt: '分析範本嘅關鍵條款',
  parsingFailed: '⚠️ 無法解析檔案，但您可以描述需求。',
  generating: '生成中...',
  generatedSuccess: '✅ 文書已生成！',
  drafterWelcome: '歡迎使用 AI 文書助手',
  drafterYouCan: '您可以：',
  drafterUploadTemplate: '上載範本畀 AI 分析',
  drafterDescribeNeeds: '描述您嘅文書需求',
  drafterLetAiHelp: 'AI 幫您起草合約、協議等',
  drafterExamples: '範例：',
  drafterExampleRental: '「幫我起草一份租約」',
  drafterExampleLabor: '「根據範本填寫僱傭合約」',
  drafterInputPlaceholder: '描述您嘅文書需求...',
  drafterThinking: '思考中...',
  drafterHistoryTitle: '歷史紀錄',
  drafterNoHistory: '暫無歷史紀錄',
  drafterNewChat: '新對話',
  drafterHistory: '歷史紀錄',
  drafterRemoveAttachment: '移除附件',
  drafterLineHeight: '行距',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: '匯出為 Word (.docx)',
  drafterExportPdf: '匯出為 PDF',
  drafterSave: '儲存文件',
  drafterDownload: '下載文件',
  drafterUndo: '復原',
  drafterRedo: '重做',
  drafterBold: '粗體',
  drafterItalic: '斜體',
  drafterStrike: '刪除線',
  drafterUnderline: '底線',
  drafterHighlight: '螢光標記',
  drafterLink: '插入連結',
  drafterAlignLeft: '靠左',
  drafterAlignCenter: '置中',
  drafterAlignRight: '靠右',
  drafterAlignJustify: '左右對齊',
  drafterList: '清單',
  drafterBulletList: '項目符號清單',
  drafterOrderedList: '編號清單',
  drafterTaskList: '工作清單',
  drafterOpenResource: '開啟資源面板',
  drafterStopGeneration: '停止生成',
  drafterAgentMode: 'Agent 模式已開啟',
  drafterAgentModeOn: 'Agent 模式已開啟',
  drafterAgentModeOff: '一般對話模式',
  drafterUploadAttachment: '上載附件',
  drafterExit: '退出',
  drafterConfirm: '確認',
  drafterOpenLink: '開啟連結',
  drafterDeleteLink: '刪除連結',
  drafterQuote: '引用',
  workflowTitle: 'AI 工作流程',
  workflowRunning: '執行中...',
  workflowReady: '準備就緒',
  workflowCompleted: '已完成',
  workflowStartFailed: '工作流程啟動失敗',
  workflowExecutionFailed: '工作流程執行失敗',
  workflowInterrupted: '工作流程已中斷',
  workflowProcessing: '處理中...',
  workflowStepsCompleted: '步驟已完成',
  workflowStepsTotal: '工作流程已完成（%{count} 個步驟）',
  acceptChanges: '接受變更',
  rejectChanges: '拒絕變更',
  changesAccepted: '已接受變更',
  changesRejected: '已拒絕變更',
  stopWorkflow: '停止',
  restartWorkflow: '重新開始',
  startDrafting: '開始起草',
  interrupt: '中斷',
  documentSubject: '文書主題 *',
  documentType: '文書類型',
  jurisdiction: '司法管轄區',
  specialRequirements: '特殊要求（選填）',
  clickStartDrafting: '按「開始起草」啟動工作流程',
  docTypeContract: '合約',
  docTypeAgreement: '協議',
  docTypeNotice: '通知',
  docTypeLetter: '函件',
  docTypePetition: '申請書',
  docTypeWill: '遺囑',
  docTypePowerOfAttorney: '委託書',
  countryChina: '中國',
  countryUSA: '美國',
  countryGermany: '德國',
  countryJapan: '日本',
  countryFrance: '法國',
  countryUK: '英國',
  citationVerified: '已驗證',
  citationUnverified: '未驗證',
  imageLoadFailed: '圖片載入失敗',
  smartDocTitle: '智能文件助手',
  smartDocChatTitle: 'AI 文書助手',
  smartDocDropPrompt: '將 PDF 檔案拖放至此',
  smartDocSelectFile: '選擇檔案',
  smartDocOr: '或',
  smartDocWelcomeTitle: '歡迎使用 AI 文書助手',
  smartDocWelcomeYouCan: '您可以：',
  smartDocUploadForAI: '上載範本畀 AI 分析',
  smartDocDescribeDoc: '描述您嘅文書需求',
  smartDocLetAIDraft: 'AI 幫您起草合約、協議等',
  smartDocExamples: '範例：',
  smartDocExampleRental: '「幫我起草一份租約」',
  smartDocExampleLabor: '「根據範本填寫僱傭合約」',
  smartDocInputPlaceholder: '描述您嘅文書需求...',
  smartDocRemoveAttachment: '移除附件',
  smartDocOpenResources: '開啟資源面板',
  smartDocExit: '退出',
  reviewStartFailed: '審查工作流程啟動失敗',
  reviewFailed: '審查失敗',
  reviewFoundIssues: '審查完成，共發現 %{count} 個問題。',
  cannotReadStream: '無法讀取回應串流',
  parseEventFailed: '解析工作流程事件失敗',
  errorPrefix: '錯誤',
  unknownError: '未知錯誤',
  file: '檔案',
  loading: '載入中...',
  localFolders: '本機資料夾',
  selectLocalFolder: '選擇本機資料夾',
  reselectFolder: '更換資料夾',
  addToContext: '傳送至對話',
  saveFile: '儲存',
  renameFile: '重新命名',
  fileSaved: '檔案儲存成功',
  fileRenamed: '檔案已重新命名為 %{name}',
  browserNotSupported: '您嘅瀏覽器唔支援本機資料夾存取',
  noFolderSelected: '選擇本機資料夾以瀏覽檔案',
  scanningFolder: '正在掃描資料夾...',
  selectFileToPreview: '選擇檔案以預覽',
  aiAnalyze: 'AI 分析',
};
